"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
const helpers_1 = require("./helpers");
/**
 * Make a network request using axios. We will map the properties passed by
 * the application to a form expected by axios, and process both success and
 * failed responses to match application expectations.
 */
const request = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const axiosRequestConfig = (0, helpers_1.prepareRequest)(options);
    return (0, axios_1.default)(axiosRequestConfig).then(helpers_1.processResponse).catch(helpers_1.processError);
});
exports.request = request;
//# sourceMappingURL=request.js.map